import React from "react";
import { EmptyState } from "@/components/EmptyState";
import { Target, Lightbulb, Users } from "lucide-react";

const CONFIG = {
  competitors: {
    icon: Target,
    overline: "Tools",
    title: "Competitors",
    empty: "Track competitor YouTube channels here. Analyze a competitor's video to start building your teardown board.",
  },
  ideas: {
    icon: Lightbulb,
    overline: "Tools",
    title: "Idea Lab",
    empty: "Turn your analyzed videos into new creative concepts. Analyze a video to generate ideas from what's working.",
  },
  team: {
    icon: Users,
    overline: "Tools",
    title: "Team & Access",
    empty: "Invite teammates to collaborate on video teardowns. Team seats are available on Premium plans.",
  },
};

export default function ComingSoon({ page }) {
  const c = CONFIG[page];
  return (
    <div className="space-y-6">
      <div>
        <p className="overline text-muted-foreground">{c.overline}</p>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mt-1">{c.title}</h1>
      </div>
      <EmptyState icon={c.icon} title="Nothing here yet" description={c.empty} />
    </div>
  );
}
